export const getCookie = (name: string) => {
  const cookies = document.cookie.split('; ')
  const targetCookie = cookies.find((row) => row.startsWith(`${name}=`))
  return targetCookie ? targetCookie.split('=')[1] : null
}

export const setTokenCookie = (name: string, value: string) => {
  const expires = new Date(Date.now() + 15 * 60 * 1000).toUTCString()
  document.cookie = `${name}=${value}; expires=${expires}; UTC; SameSite=Lax; Secure; path=/`
}
